export const Zone = [
    { name: 'EAST', code: 'EAST' },
    { name: 'WEST', code: 'WEST' },
    { name: 'NORTH', code: 'NORTH' },
    { name: 'SOUTH', code: 'SOUTH' },
    { name: 'INTERNATIONAL', code: 'INTERNATIONAL' },
]